<template>
  <div class="app-container">
    <div class="screen-search">
      <div class="approval-process">
        <el-button :class="[isFocus ? 'active disposal' : '']" size="medium" type="text" @click="handleDisposal">待办({{ disposalNum }})
        </el-button>
        <el-button
          :class="[isFocus ? 'processed' : 'active processed']"
          size="medium"
          type="text"
          @click="handleProcessed">
          已办
        </el-button>
      </div>
      <el-search
        :form-item-data="formItemData"
        :rules="rules"
        :is-show.sync="isShow"
        :span="8"
        @onSubmitSingle="onSubmitSingle"
        @onSubmitMulti="onSubmitMulti">
        <el-button class="agent-btn" size="mini" type="primary" icon="icon-ccui-appoint" @click="handleAgent">指定代理
        </el-button>
      </el-search>
    </div>
    <div class="table-wapper">
      <el-popover
        v-model="visible"
        placement="bottom"
        title="标题"
        width="140"
        trigger="click"
      >
        <el-checkbox-group v-model="checkboxVal">
          <template v-for="(item,index) in formTheadOptions">
            <el-checkbox :key="index" :label="item" :checked="checked" :width="item.width">{{ item.label }}</el-checkbox>
          </template>
        </el-checkbox-group>
        <div slot="reference" class="hidden-btn"/>
      </el-popover>
      <el-table
        ref="multipleTable"
        :data="tableData"
        :key="key"
        :fit="true"
        :row-style="rowClass"
        border
        style="width: 100%"
        class="detail"
        @row-click="jumpToDetail"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"/>
        <el-table-column v-for="(table, index) in formThead" :key="index" :label="table.label" :width="table.width" :prop="table.prop" :show-overflow-tooltip="true">
          <template slot-scope="scope">{{ scope.row[table.prop] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              class="approval-btn"
              @click="handleEdit(scope.$index, scope.row)">审批
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :render-header="renderLastHeader" width="36"/>
      </el-table>
      <div class="table-footer">
        <div v-show="isSelection" class="operation">
          <el-button size="mini" class="btn-approval" type="default-bottom" @click="handleApproval">批量审批</el-button>
          <el-button size="mini" class="btn-export" type="default-bottom" @click="handleExport">导出<i
            class="el-icon-caret-top"/></el-button>
        </div>
        <div class="paging">
          <el-pagination
            :total="disposalNum"
            :current-page.sync="currentPage3"
            :page-size="5"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout="prev, pager, next, total, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"/>
          <el-button class="pagination-btn" size="medium" type="default-bottom" @click="handleSizeChange">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getList } from '@/api/approve-contract'
import {
  Popover,
  CheckboxGroup,
  Checkbox,
  Pagination,
  Button
} from 'ccui'

const defaultFormThead = [
  { label: '序号', prop: 'id', width: 50, title: 'id' },
  { label: '统一信用代码', prop: 'creditCode', width: 180, title: 'creditCode' },
  { label: '供应商名称', prop: 'supplierName' },
  { label: '简称', prop: 'abbreviation' },
  { label: '类型', prop: 'type', width: 150 },
  { label: '所在省/地区', prop: 'region' },
  { label: '申请类型', prop: 'applyType', width: 110 },
  { label: '审批状态', prop: 'state', width: 110 }
  // { label: '操作', width: 80 }
]
export default {
  components: {
    Popover,
    CheckboxGroup,
    Checkbox,
    Pagination,
    Button
  },
  data() {
    return {
      checked: true,
      tableDataContent: [],
      selectRow: [],
      selectData: [],
      code: [],
      isFocus: true,
      isSelection: false,
      disposalNum: 0,
      currentPage1: 1,
      currentPage2: 2,
      currentPage3: 3,
      currentPage4: 4,
      formItemData: [
        {
          id: '1',
          type: 'input',
          placeHolder: '供应商名称:',
          // name: 'contractName',
          label: '供应商名称:',
          value: '',
          outputValue: ''
        },
        {
          id: '2',
          type: 'select',
          placeHolder: '类型:',
          name: 'contractNum',
          label: '类型:',
          value: '',
          outputValue: '',
          option: [
            {
              value: '1',
              label: '类型1A'
            }, {
              value: '2',
              label: '类型2B'
            }, {
              value: '3',
              label: '类型1C'
            }, {
              value: '4',
              label: '类型1D'
            }, {
              value: '5',
              label: '类型1E'
            }
          ]
        }, {
          id: '3',
          type: 'input',
          placeHolder: '所在省/地区:',
          name: 'managingUnit',
          label: '所在省/地区:',
          value: '',
          outputValue: ''
        }, {
          id: '4',
          type: 'input',
          placeHolder: '申请类型:',
          name: 'contractFirst',
          label: '申请类型:',
          value: '',
          outputValue: ''
        }, {
          id: '5',
          type: 'input',
          placeHolder: '审批状态:',
          name: 'contractLast',
          label: '审批状态:',
          value: '',
          outputValue: ''
        }

      ],
      rules: {
        contractName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      value: '',
      k: 1,
      isShow: false,
      input: '',
      isIndeterminate: false,
      visible: false,
      checkAll: false,
      tableData: [],
      key: 1, // table key
      formTheadOptions: [
        { label: '序号', prop: 'id', width: 50, title: 'id' },
        { label: '统一信用代码', prop: 'creditCode', width: 180, title: 'creditCode' },
        { label: '供应商名称', prop: 'supplierName' },
        { label: '简称', prop: 'abbreviation' },
        { label: '类型', prop: 'type', width: 150 },
        { label: '所在省/地区', prop: 'region' },
        { label: '申请类型', prop: 'applyType', width: 110 },
        { label: '审批状态', prop: 'state', width: 110 }
        // { label: '操作', width: 80 }
      ],
      checkboxVal: defaultFormThead, // checkboxVal
      formThead: defaultFormThead // 默认表头 Default header
    }
  },

  watch: {
    checkboxVal(valArr) {
      this.formThead = this.formTheadOptions.filter(i => valArr.indexOf(i) >= 0)
      this.key = this.key + 1 // 为了保证table 每次都会重渲 In order to ensure the table will be re-rendered each time
    },
    $route(to, from) {
      this.fetchDate()
      console.log('to from')
      console.log(to)
      console.log(from)
    },
    selectData(data) {
      this.selectRow = []
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(this.tableData.indexOf(item))
        })
      }
    }
  },

  created() {
    this.getList()
    this.getTableDataContent()
  },
  methods: {
    handleSelectionChange(data) {
      this.selectData = data
    },
    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { 'background-color': 'rgba(255,232,195,1) ' }
      }
    },
    handleEdit(index, row) {
      console.log('单行审批', index, row)
    },
    handleAgent() {
      console.log('指定代理')
    },
    handleApproval() {
      console.log('批量审批', this.code)
    },
    handleExport() {
      console.log('导出', this.code)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.getList()
    },
    onSubmitMulti(obj) {
      console.log('多字段查询')
      console.log(obj)
      this.getList()
    },
    onSubmitSingle(obj) {
      console.log('单字段查询')
      console.log(obj)
      this.getList()
    },
    jumpToDetail(row, col, e) {
      // console.log('wwwwwwwwwww')
      console.log(row)
      console.log(col)
      console.log(e)
      if (row.id) {
        this.$router.push('/approval/supplier/supplier-detail/' + row.id)
      } else {
        this.$message('查看详情请点击有id的行')
      }
    },
    searchShow() {
      this.isShowVal = !this.isShowVal
      this.isShow = !this.isShow
    },
    onSubmit() {
      console.log(this.formInline)
      console.log(this.type.value)
      console.log(this.price.value)
      console.log(this.approval.value)
    },
    onClear() {
      for (var i in this.formInline) {
        this.formInline[i] = ''
        break
      }
      this.type.value = ''
      this.price.value = ''
      this.approval.value = ''
    },
    handleDisposal() {
      this.isFocus = true
      this.getList()
    },
    handleProcessed() {
      this.isFocus = false
      this.getList()
    },

    getList() {
      const contentHeight = document.body.clientHeight
      const tableHeight = contentHeight - 342
      const tableNumber = parseInt(tableHeight / 36)
      console.log('iiiii', contentHeight, tableHeight, tableNumber)
      getList({
        pageNo: 3,
        pageSize: tableNumber,
        isShowLoading: true
      }).then(res => {
        console.log('xpppppp', res.data.data)
        this.tableData = res.data.data
        this.disposalNum = res.data.data.length
        for (let i = 0; i < this.disposalNum; i++) {
          console.log(this.tableData[i])
          this.tableDataContent = this.tableData[i]
          // console.log('uuuuu', this.tableDataContent)
        }
      })
    },
    getTableDataContent() {
      console.log('wwwwwww', this.tableData)
    },
    fetchDate() {
      console.log('路由发生变化了')
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false
      // console.log('xxxxxxx', val)
      const arr = []
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id)
      }
      this.code = arr
      if (val.length) {
        this.isSelection = true
      } else {
        this.isSelection = false
      }
      if (typeof val === 'boolean') {
        if (val) {
          console.log('xxxxxx', this.toggleSelection)
          this.toggleSelection(this.tableData)
        } else {
          this.toggleSelection([])
        }
      } else {
        this.checkAll = val.length !== 0
      }
    },
    handleCheckChange(val) {
      console.log('handleCheckChange')
      // console.log('fffffff', val)
      const arr = []
      for (let i = 0; i < val.length; i++) {
        // console.log('lllllll', val[i].id)
        // console.log(this.code)
        arr.push(val[i].id)
      }
      // console.log('ppppp', arr)
      this.code = arr
      if (val.length) {
        this.isSelection = true
      } else {
        this.isSelection = false
      }
      if (val.length > 0 && val.length < 2) {
        this.isIndeterminate = true
      } else if (val.length === 2) {
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkAll = false
        this.isIndeterminate = false
      }
    },
    toggleSelection(rows) {
      console.log('ttttttt', this.$refs.multipleTable)
      this.$refs.multipleTable.clearSelection()
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      }
    },
    renderLastHeader(h, { column, $index }) {
      column.minWidth = 55
      column.realWidth = 55
      return h('span', {}, [
        h('svg-icon', {
          props: {
            iconClass: 'setup'
          },
          on: {
            click: () => {
              this.showControlPanel()
            }
          },
          slot: 'reference'
        })
      ])
    },
    showControlPanel() {
      this.visible = !this.visible
    },
    sizeChangeHandler(e) {
    },
    pageChangeHandler(e) {
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-main {
    .el-tabel {
      margin-bottom: 70px;
    }

    .app-container {
      padding: 0 20px;
      background: #ffffff;

      .screen-search {
        .approval-process {
          position: relative;
          top: 13px;
          width: 200px;
          z-index: 10;

          .el-button {
            color: rgba(74, 74, 74, 1);
            font-weight: 500;
          }

          .processed {
            margin-left: 25px;
          }

          .active {
            color: #004898;
            border-bottom: 2px solid rgba(7, 91, 186, 1);
            border-radius: 0;
            font-weight: 600;
            font-size: 14px;
          }
        }

        .el-search {
          position: relative;
          bottom: 18px;

          /deep/ .el-search-bar {
            /*max-width: 340px !important;*/
              .searcher{
                .el-input__inner{
                  margin-left: 10px;
                }
              }
            /deep/ .search-icon-open {
              /*width: 30px;*/
            }
          }

           .agent-btn {
            width: 115px;
            height: 30px;
            border-radius: 2px;
            color: rgba(255, 255, 255, 1);
            padding: 0;
            font-size:14px;
            font-weight:400;
            /deep/ .icon-ccui-appoint{
              margin-right:3px ;
              /*font-size: 18px;*/
            }
          }
        }
      }

      .table-wapper {
        /*.el-table{*/
        /*  .el-table__body-wrapper{*/
        /*    .el-table__body{*/
        /*      tbody{*/
        /*        tr{*/
        /*          /deep/ td{*/
        /*            .cell{*/
        /*              overflow: hidden;*/
        /*              text-overflow: ellipsis !important;*/
        /*              white-space: nowrap;*/
        /*            }*/
        /*            .el-tooltip{*/
        /*              background: red;*/
        /*            }*/
        /*          }*/
        /*        }*/
        /*      }*/
        /*    }*/
        /*  }*/
        /*}*/
        /*.el-table {*/
        /*  border-top: none;*/
        /*  .el-table__header-wrapper {*/
        /*    font-size: 13px;*/
        /*    color: #4A4A4A;*/
        /*    font-weight: 600;*/
        /*    border-top: 1px solid #D8D8D8;*/
        /*    border-bottom: 1px solid #D8D8D8;*/
        /*    .has-gutter {*/
        /*      th {*/
        /*        border-right: none;*/
        /*        color: rgba(74, 74, 74, 1);*/
        /*        padding-top: 0;*/
        /*        padding-bottom: 0;*/
        /*        border-bottom: none;*/
        /*        line-height: 40px;*/
        /*      }*/
        /*    }*/
        /*  }*/
        /*  .el-table__body-wrapper {*/
        /*    font-size: 13px;*/
        /*    color: #4A4A4A;*/
        /*    font-weight: 400;*/
        /*    .el-table__row {*/
        /*      height: 36px !important;*/
        /*      /deep/ td {*/
        /*        border-right: none;*/
        /*        overflow:hidden;*/
        /*        text-overflow:ellipsis;*/
        /*        white-space:nowrap;*/
        /*        border-bottom: 1px solid #F1F1F1;*/
        /*        .approval-btn {*/
        /*          font-size: 13px ;*/
        /*          font-weight:400;*/
        /*          color: #5576CF;*/
        /*        }*/
        /*      }*/
        /*    }*/
        /*  }*/
        /*}*/

        .hidden-btn {
          position: absolute;
          top: 16px;
          right: 5px;
        }

        /deep/ .table-footer {
          height: 70px;
          line-height: 70px;
          background-color: #ffffff;
          z-index: 5;
          width: 100%;

          .operation {
            float: left;
            .btn-approval{
              width:68px;
              height:30px;
              font-size:13px;
              font-weight:400;
              color:rgba(74,74,74,1);
              padding:7px 0;
            }
            .btn-export {
              width: 56px;
              height: 30px;
              font-size:13px;
              font-weight:400;
              color:rgba(74,74,74,1);
              margin-left: 5px;
            }

            button {
              background: rgba(246, 246, 246, 1);
              border: 1px solid rgba(221, 221, 221, 1);
              width: 68px;

              .icon-ccui-down {
                font-size: 8px;
                display: inline-block;
                transform: rotate(60deg);
              }
            }
          }

          .paging {
            float: right;
            padding-top: 20px;
            padding-right: 20px;
            height: 70px;
            display: flex;
            .el-pagination {
              color: #666666;
              font-weight: 400;
              :disabled{
                color:rgba(102,102,102,0.3);
              }
              button {
                margin-right: 3px;
                font-size: 14px;
              }

              .el-pager {
                font-size: 14px;

                .number {
                  font-size: 14px;
                  width: 30px;
                  height: 30px;
                  color: #666666;
                  background: rgba(246, 246, 246, 1);
                  border: 1px solid rgba(221, 221, 221, 1);
                  margin: 0;
                  margin-right: 3px;
                  border-radius: 0;
                }

                .more {
                  font-size: 14px;
                  width: 30px;
                  height: 30px;
                  color: #666666;
                  background: rgba(0, 0, 0, 0);
                  margin: 0;
                  margin-right: 3px;
                  border-radius: 0;
                }

                .active {
                  width: 30px;
                  height: 30px;
                  background-color: #ffffff !important;
                  color: #075BBA !important;
                  border: none;
                }
              }
            }

            .pagination-btn {
              width: 42px !important;
              height: 30px !important;
              background: rgba(246, 246, 246, 1) !important;
              border: 1px solid rgba(221, 221, 221, 1) !important;
              border-radius: 0;
              padding: 0 !important;
              font-size:14px;
              font-weight:400;
              color:rgba(102,102,102,1);
            }

            /*justify-content: space-between;*/
            .el-button {
              width: 65px;
              height: 30px;
              background: rgba(246, 246, 246, 1);
              border: 1px solid rgba(221, 221, 221, 1);
              display: block;
            }
            .btn-prev {
              border-radius: 0;
              width: 72px;
              height: 30px;
              background: rgba(246, 246, 246, 1);
              border: 1px solid rgba(221, 221, 221, 1);
              font-size: 14px;
              color: #666666;

              span {
                font-size: 14px;
              }
            }

            .btn-next {
              border-radius: 0;
              width: 72px;
              height: 30px;
              background: rgba(246, 246, 246, 1);
              border: 1px solid rgba(221, 221, 221, 1);
              margin: 0;
              font-size: 14px;
              color: #666666;

              span {
                font-size: 14px;
              }
            }

            .el-pagination__total {
              font-size: 12px;
              color: #666666;
              font-weight: 400;
              margin: 1px 0 0 8px;
            }

            .el-pagination__jump {
              font-size: 12px;
              color: #666666;
              font-weight: 400;
              margin-left: 5px;

              .el-pagination__editor {
                width: 35px;

                .el-input__inner {
                  border-radius: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  body{
     .el-popover{
      background: red;
    }
  }
</style>

